import { render, staticRenderFns } from "./ViewTaskModal.vue?vue&type=template&id=7bb4642f"
import script from "./ViewTaskModal.vue?vue&type=script&lang=js"
export * from "./ViewTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports